<template>
  <div>
    <div align="left">
      <span style="margin-right: 5px">核销区县报表</span>
      <el-input v-model="year" placeholder="请输入年份，如2025" style="width: 200px"></el-input>
      <el-select v-model="level" placeholder="医院级别" style="width: 150px" @change="buildTabs">
        <el-option label="全部级别" value="all"></el-option>
        <el-option label="二级及以上" value="secondPlus"></el-option>
        <el-option label="二级以下" value="belowSecond"></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-circle-plus" :loading="loading" @click="getReport">确定</el-button>
      <el-button type="success" icon="el-icon-download" :disabled="tabs.length===0" @click="exportExcel">导出Excel</el-button>
    </div>

    <el-tabs v-model="activeName" type="card" v-if="tabs.length>0" style="margin-top: 10px">
      <el-tab-pane
        v-for="(tab,index) in tabs"
        :key="tab.name"
        :label="tab.name"
        :name="tab.name">
        <el-table
          :data="tab.list"
          border
          style="width: 100%"
          max-height="100%"
          :row-class-name="rowClass">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            :index="indexMethod">
          </el-table-column>
          <el-table-column
            prop="hospital_code"
            label="医院编号"
            width="160">
          </el-table-column>
          <el-table-column
            prop="hospital_name"
            label="医院名称"
            width="260">
          </el-table-column>
          <el-table-column
            prop="year"
            label="年份"
            width="80">
          </el-table-column>
          <el-table-column
            prop="weight"
            label="总重量（公斤）"
            width="140">
            <template slot-scope="scope">
              <span :style="scope.row.weight<0?'color:#F56C6C':''">{{rowVal(scope.row.weight,1000)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            label="单价（元）"
            width="140">
            <template slot-scope="scope">
              <span :style="scope.row.price<0?'color:#F56C6C':''">{{rowVal(scope.row.price,100)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="amount"
            label="总金额（元）"
            width="140">
            <template slot-scope="scope">
              <span :style="scope.row.amount<0?'color:#F56C6C':''">{{rowVal(scope.row.amount,100)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="last_balance"
            label="上年余额（元）"
            width="140">
            <template slot-scope="scope">
              <span :style="scope.row.last_balance<0?'color:#F56C6C':''">{{rowVal(scope.row.last_balance,100)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="deposit"
            label="本年度充值（元）"
            width="140">
            <template slot-scope="scope">
              <span :style="scope.row.deposit<0?'color:#F56C6C':''">{{rowVal(scope.row.deposit,100)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="balance"
            label="余额（元）"
            width="140">
            <template slot-scope="scope">
              <span :style="scope.row.balance<0?'color:#F56C6C':''">{{rowVal(scope.row.balance,100)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="time"
            label="核销时间"
            width="170">
            <template slot-scope="scope">
              {{formatTime(scope.row.time)}}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import coder from "./enum.js"
import excel from "./excel.js"
import hospitalGrade from "./hospitalGrade.js"
export default {
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    toFixed2(val){
      let num=(Math.trunc(val*100)/100).toFixed(2).split('.');
      num[0]=num[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return num.join('.');
    },
    rowVal(val,divider){
      if (val===null||val===undefined||val==='') return '';
      return this.toFixed2(val/divider);
    },
    rowClass({row}){
      if (row.isSummary){
        return 'summary-row';
      }
      return '';
    },
    trunc2(val){
      return Math.trunc(val*100)/100;
    },
    formatTime(time) {
      if (time === null || time === undefined || time === '') {
        return '';
      }
      const date = new Date(time);
      if (isNaN(date.getTime())) {
        return time;
      }
      const pad = n => (n < 10 ? '0' + n : '' + n);
      return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) +
        ' ' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
    },
    getReport(){
      if (this.loading){ return }
      if (this.year===''||!/^\d{4}$/.test(this.year)){
        this.$alert('请输入正确的年份', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      this.loading=true;
      window.ws.Call("W2S_VerificationAreaReport", this.year);
    },
    exportExcel(){
      if (this.tabs.length===0){ return }
      let $this=this;
      let headers = ['序号','医院编号','医院名称','年份','总重量（公斤）','单价（元）','总金额（元）','上年余额（元）','本年度充值（元）','余额（元）','核销时间'];
      let sheets = [];
      for(let i=0;i<this.tabs.length;i++){
        let data = this.tabs[i].list.map((d,idx)=>[
          idx+1,
          d.hospital_code,
          d.hospital_name,
          d.year,
          d.weight===null||d.weight===undefined?'':$this.trunc2(d.weight),
          d.price===null||d.price===undefined?'':$this.trunc2(d.price),
          d.amount===null||d.amount===undefined?'':$this.trunc2(d.amount),
          d.last_balance===null||d.last_balance===undefined?'':$this.trunc2(d.last_balance),
          d.deposit===null||d.deposit===undefined?'':$this.trunc2(d.deposit),
          d.balance===null||d.balance===undefined?'':$this.trunc2(d.balance),
          $this.formatTime(d.time)
        ]);
        sheets.push({name:this.tabs[i].name, headers:headers, data:data, title:this.tabs[i].name+'（'+this.year+'年，'+this.levelName()+'）'});
      }
      excel.buildXlsxWorkbook(sheets, '医废核销区县统计表（'+this.year+'年，'+this.levelName()+'）.xlsx');
    },
    levelMatch(code){
      if (this.level==='all') return true;
      let plus=hospitalGrade.isSecondPlus(code);
      return this.level==='secondPlus'?plus:!plus;
    },
    levelName(){
      if (this.level==='secondPlus') return '二级及以上';
      if (this.level==='belowSecond') return '二级以下';
      return '全部级别';
    },
    buildTabs(){
      if (this.rawRes===undefined||this.rawRes===null){ return }
      let tabs = [];
for(let i=0;i<this.rawRes.length;i++){
        let rows = [];
        for(let j=0;j<this.rawRes[i].List.length;j++){
          let d=this.rawRes[i].List[j];
          if (!this.levelMatch(d.hospital_code)) continue;
          rows.push({
            hospital_code:d.hospital_code,
            hospital_name:d.hospital_name,
            year:d.year,
            weight:d.weight,
            price:d.price,
            amount:d.amount,
            last_balance:d.last_balance,
            deposit:d.deposit,
            balance:d.balance,
            time:d.time,
            operator:d.operator,
          });
        }
        rows.sort(function(a,b){ return (a.hospital_code - b.hospital_code) || a.hospital_code.localeCompare(b.hospital_code); });
        let sumWeight=0,sumAmount=0,sumLastBalance=0,sumDeposit=0,sumBalance=0;
        for(let j=0;j<rows.length;j++){
          sumWeight+=rows[j].weight;
          sumAmount+=rows[j].amount;
          sumLastBalance+=rows[j].last_balance;
          sumDeposit+=rows[j].deposit;
          sumBalance+=rows[j].balance;
        }
        rows.push({
          hospital_code:'合计',
          hospital_name:'',
          year:'',
          weight:sumWeight,
          price:null,
          amount:sumAmount,
          last_balance:sumLastBalance,
          deposit:sumDeposit,
          balance:sumBalance,
          time:'',
          operator:'',
          isSummary:true,
        });
        tabs.push({name:this.rawRes[i].Name,list:rows});
      }
      this.tabs=tabs;
      if (tabs.length>0){
        this.activeName=tabs[0].name;
      }else{
        this.activeName='';
      }
    },
  },
  mounted() {
    let $this=this;
    console.log("###Page loaded !");
    this.year=(new Date().getFullYear()).toString();
    window.ws.AddFunc("S2W_VerificationAreaReportRes",function (code,err,res) {
      console.log("S2W_VerificationAreaReportRes:",code,err,res)
      $this.loading=false;
      if (code==coder.OK){
        $this.rawRes=res;
        $this.buildTabs();
      }else{
        $this.$alert(err+'('+code+')', '错误', {
          confirmButtonText: '确定'
        });
      }
    });
  },
  data() {
    return {
      tabs: [],
      activeName:'',
      year:'',
      level:'belowSecond',
      rawRes:null,
      loading:false,
    }
  }
}
</script>

<style scoped>
  >>> .summary-row {
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/view/VerificationAreaReport.vue